export default __webpack_public_path__ + "static/media/info.41487d90.svg";